import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useParlamentarianCreateEditDispatch, useParlamentarianCreateEditState } from './parlamentarian-create-edit-context';
import ParlamentarianAppService from '../../../../application/platform/sge/parlamentarian/parlamentarian-app-service';
import PoliticalPartyAppService from '../../../../application/platform/sge/political-party/political-party-app-service';
import { useBaseLayout } from '../../../../components/context/use-base-layout';
import { IPoliticalPartyPagedResponse } from '../../../../model/sge/political-party/response/political-party-paged-response';

export const useParlamentarianCreateEditController = () => {
    const navigate = useNavigate();
    const dispatch = useParlamentarianCreateEditDispatch();
    const state = useParlamentarianCreateEditState();
    const { showMessage, showLoading } = useBaseLayout();
    const [isSaving, setIsSaving] = useState(false);
    const [politicalParties, setPoliticalParties] = useState<IPoliticalPartyPagedResponse[]>([]);

    useEffect(() => {
        async function loadInitialData() {
            showLoading({ open: true });
            try {
                const parties = await PoliticalPartyAppService.listAll();
                setPoliticalParties(parties);

                if (state.parlamentarianId) {
                    const data = await ParlamentarianAppService.getById(Number(state.parlamentarianId));
                    dispatch({
                        type: ACTION_TYPES.setParlamentarianRequest,
                        payload: {
                            name: data.personName,
                            type: data.type ? Number(data.type) : undefined,
                            politicalPartyId: data.politicalPartyId,
                            isActive: data.isActive,
                            contact: {
                                email: data.contactEmail,
                                phone: data.contactPhone,
                                mobile: data.contactMobile,
                                commercialPhone: data.contactCommercialPhone,
                            }
                        }
                    });
                }
            } catch (error: any) {
                showMessage({ open: true, message: 'Não foi possível carregar os dados do parlamentar', detail: error?.details || error?.message, type: 'error' });
            } finally {
                showLoading({ open: false });
            }
        }
        loadInitialData();
    }, [state.parlamentarianId]);

    function handleOnChange(e: any) {
        const { name, value, checked, type } = e.target;
        dispatch({ type: ACTION_TYPES.updateParlamentarianRequest, payload: { [name]: type === 'checkbox' ? checked : value } });
    }

    function handleContactChange(e: any) {
        dispatch({ type: ACTION_TYPES.updateContact, payload: { [e.target.name]: e.target.value } });
    }

    async function handleSave() {
        if (!state.parlamentarianRequest.name || !state.parlamentarianRequest.type) {
            dispatch({ type: ACTION_TYPES.setShowValidationErrors, payload: true });
            return;
        }
        setIsSaving(true);
        try {
            if (state.parlamentarianId) {
                await ParlamentarianAppService.edit(Number(state.parlamentarianId), state.parlamentarianRequest);
                showMessage({ open: true, message: 'Parlamentar atualizado com sucesso!', type: 'success' });
            } else {
                await ParlamentarianAppService.add(state.parlamentarianRequest);
                showMessage({ open: true, message: 'Parlamentar adicionado com sucesso!', type: 'success' });
            }
            setTimeout(() => navigate('/parlamentares'), 1500);
        } catch (error: any) {
            showMessage({ open: true, message: 'Não foi possível salvar o parlamentar', detail: error?.details || error?.message, type: 'error' });
        } finally {
            setIsSaving(false);
        }
    }

    function handleCancel() {
        navigate('/parlamentares');
    }

    return { handleOnChange, handleContactChange, handleSave, handleCancel, isSaving, politicalParties };
};
